/**
 * Helpers de assets para PDFs generados con jsPDF.
 */

/** Carga una imagen, la redimensiona (menos peso) y devuelve base64 PNG + ratio.
 * Con timeout de seguridad: si el browser nunca dispara onload/onerror, resuelve
 * null a los 3s y el PDF sale sin logo en vez de colgarse. */
export function loadImageForPDF(src, maxWidth = 300) {
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(null), 3000);
    const done = (value) => {
      clearTimeout(timer);
      resolve(value);
    };
    const img = new Image();
    img.onload = () => {
      const ratio = img.naturalWidth / img.naturalHeight;
      const w = Math.min(img.naturalWidth, maxWidth);
      const h = Math.round(w / ratio);
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      done({ data: canvas.toDataURL("image/png"), ratio });
    };
    img.onerror = () => done(null);
    img.src = src;
  });
}
